const env = import.meta.env.VITE_ENVIRONMENT;

export const StagingBanner = () => {
  if (!env || env === "production") return null;

  return (
    <div className="bg-amber-500 text-white text-center text-xs font-semibold py-1 px-4">
      STAGING ENVIRONMENT
    </div>
  );
};
